import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled, { css } from 'styled-components'

export const LinkHelp = styled.a`
  position: absolute;
  right: 57px;
  bottom: 57px;
  z-index: 1000;
`

export const ButtonHelp = styled.div<{ openHelp?: boolean }>`
  background-color: ${tokens.colors.dark1};
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  cursor: pointer;
  transition: ${tokens.transitions.default};
  box-shadow: ${tokens.shadows.shadowDown8};
  background-color: ${tokens.colors.white};

  > strong {
    display: none;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 14px;
    width: 0px;
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    color: ${tokens.colors.dark5};
    line-height: 14px;
    transition: ${tokens.transitions.default};
    text-decoration-line: underline;
  }

  ${({ openHelp }) =>
    openHelp &&
    css`
      width: 309px;
      > strong {
        width: max-content;
        display: -webkit-box;
      }
    `}

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: none;
  }
`
